// https://www.tjvantoll.com/2015/09/13/fetch-and-errors/

export default function handleErrors(response) {
  if (!response.ok) {
    throw response;
  }
  return response;
}



// WEBPACK FOOTER //
// ./library/app/actions/handleErrors.js